/** For books: business P&L vs household, independent of which bank account the charge hit. */
export const TX_CLASSIFICATION_OPTIONS = [
    { value: '', label: 'Unclassified' },
    { value: 'BUSINESS', label: 'Business' },
    { value: 'PERSONAL', label: 'Personal' },
];

export const TX_CLASSIFICATION_MAP = Object.fromEntries(
    TX_CLASSIFICATION_OPTIONS.filter((o) => o.value).map((o) => [o.value, o.label])
);
